export const DEVELOPMENT_ENGLISH_LOCALE = 'en-US';

export const isEnglishLocaleEnabled = (env = process.env) => {
  return env?.NODE_ENV === 'development' && env?.ENABLE_ENGLISH === 'true';
};

export const resolveDevelopmentLocaleConfig = (appConfig, env = process.env) => {
  if (!isEnglishLocaleEnabled(env)) {
    return appConfig;
  }

  return {
    ...appConfig,
    localization: {
      ...appConfig.localization,
      locale: DEVELOPMENT_ENGLISH_LOCALE,
    },
  };
};

export const resolveDevelopmentHostedTranslations = (
  hostedTranslations = {},
  env = process.env
) => {
  return isEnglishLocaleEnabled(env) ? {} : hostedTranslations;
};
